<template>
  <div class="pb-10">
    <app-header v-if="isAuthenticated" />
    <app-notifications />
    <div :class="container_class">

      <router-view />
    </div>
  </div>
</template>

<script>

import AppHeader from "@/components/views/layout/AppHeader.vue";
import AppNotifications from "./components/views/layout/AppNotifications.vue";

export default {
  components: {
    "app-header": AppHeader,
    "app-notifications": AppNotifications,
  },
  computed: {
    container_class: function () {
      if (!this.isAuthenticated) return "";
      return "max-full mx-auto sm:px-6 lg:px-8";
    },
  },
};
</script>
